<template>
  <div id="sinfo" style="padding: 0;height: 100%; box-sizing: border-box;">
    <iframe id="printf" src="" width="0" height="0" frameborder="0" style="display: none;"/>
    <div class="com-model" v-if="resumeInfo">
      <header class="flex flex-between">
        <div class="left">
          <div class="flex top">
            <div class="back-c" @click="$router.go(-1)">
              <i class="el-icon-arrow-left"/>
            </div>
            <div class="top-tit">简历详情</div>
          </div>
          <div class="flex bottom">
            <span>应聘岗位：<font>{{ resumeInfo.workerInfo.recruitTitle || '无' }}</font></span>
            <template v-if="resumeInfo.workerInfo.recruitTitle">
              <span class="post-status">招聘中</span>
              <span class="split-line"/>
              <span>发布时间：{{ recruitInfo.createdAt.split(' ')[0] }}</span>
            </template>
          </div>
        </div>
        <el-steps :space="100" :active="stepActive">
          <el-step title="简历下载" icon="circle-check"/>
          <el-step title="简历筛选" icon="circle-check"/>
          <el-step title="通过面试" icon="circle-check"/>
          <el-step title="入职上岗" icon="circle-check"/>
        </el-steps>
      </header>
      <div style="padding: 34px 24px 24px 0;" class="body-content" id="printOrder-data">
        <div class="marginLeft" :style="`${flex} ${flexBetween} margin-bottom: 28px;`">
          <div :style="`${flex} margin-top: 50px;`">
            <img v-if="resumeInfo.workerInfo.headImage"
                 :src="resumeInfo.workerInfo.headImage"
                 alt=""
                 class="person"
                 style="width: 68px; height: 68px; border-radius: 34px; margin-right: 16px;"/>
            <img class="person" src="//oss.51ztx.com/resu.png" v-else
                 style="width: 68px; height: 68px; border-radius: 34px; margin-right: 16px;"
                 alt=""/>
            <div>
              <div class="name"
                   style="font-weight: bold; font-size: 22px; color: #141414; line-height: 28px; margin-bottom: 10px;">
                {{ resumeInfo.workerInfo.name }}
                <img class="icon-sex" :src="IconSex" style="width: 16px; height: 16px; margin-left: 6px;" alt=""/>
              </div>
              <div class="oinfo flex"
                   :style="`${flex} font-size: 16px; color: rgba(51,51,51,0.85); line-height: 14px;`">
                <font>{{ resumeInfo.workerInfo.sex || '不限' }}</font>
                <span v-if="resumeInfo.workerInfo.age" style="margin-left: 25px;">
                  {{ resumeInfo.workerInfo.age }}岁
                </span>
                <span v-if="resumeInfo.workerInfo.educationName" style="margin-left: 25px;">
                  {{ resumeInfo.workerInfo.educationName }}
                </span>
                <span v-if="resumeInfo.workerInfo.homeProvincename && resumeInfo.workerInfo.homeCityname"
                      style="margin-left: 25px;">
                  {{ resumeInfo.workerInfo.homeProvincename }}{{ resumeInfo.workerInfo.homeCityname}}
                </span>
                <span v-if="resumeInfo.workerInfo.experience" style="margin-left: 25px;">
                  {{ resumeInfo.workerInfo.experience}}
                </span>
                <span v-if="resumeInfo.workerInfo.phone" style="margin-left: 25px;">
                  {{ resumeInfo.workerInfo.phone }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div :style="`${flex} margin-bottom: 20px; align-items: flex-start;`">
          <div :style="iItem">
            <span style="font-size: 14px; color: #5C6874; line-height: 20px; margin-bottom: 8px;">更新日期</span>
            <div style="font-size: 16px; color: #2A2F4C; line-height: 20px;">
              {{ resumeInfo.workerInfo.updatedAt.split(" ")[0] }}
            </div>
          </div>
          <!--<div class="i-item flex flex-column align-start" :style="iItem">
            <span style="font-size: 14px; color: #5C6874; line-height: 20px; margin-bottom: 8px;">期望薪资</span>
            <div style="font-size: 16px; color: #2A2F4C; line-height: 20px;"
                 v-if="resumeInfo.workerInfo.expectMinsalary && resumeInfo.workerInfo.expectMaxsalary">
              {{ `${resumeInfo.workerInfo.expectMinsalary || ''}~${resumeInfo.workerInfo.expectMaxsalary || ''}` }}
            </div>
            <div style="font-size: 16px; color: #2A2F4C; line-height: 20px;" v-else>未填</div>
          </div>
          <div class="i-item flex flex-column align-start">
            <span style="font-size: 14px; color: #5C6874; line-height: 20px; margin-bottom: 8px;">期望岗位</span>
            <div style="font-size: 16px; color: #2A2F4C; line-height: 20px;">{{ resumeInfo.workerInfo.expectPositionname || '未填' }}</div>
          </div>-->
          <div class="i-item flex flex-column align-start" :style="iItem">
            <span style="font-size: 14px; color: #5C6874; line-height: 20px; margin-bottom: 8px;">最近浏览岗位</span>
            <div :style="`${flex}`">
              <span style="font-size: 16px; color: #2A2F4C; line-height: 20px; margin-right: 7px;">
                {{ resumeInfo.workerInfo.latelyBrowse || '无' }}
              </span>
              <div :style="{color: getActivityStatus.color, backgroundColor: getActivityStatus.bg}"
                   style="width: 88px; height: 22px; border-radius: 4px; font-size: 16px; text-align: center; line-height: 22px;">
                {{ getActivityStatus.text }}
              </div>
            </div>
          </div>
          <!--<div class="i-item flex flex-column align-start">
            <span style="font-size: 14px; color: #5C6874; line-height: 20px; margin-bottom: 8px;">期望地点</span>
            <div style="font-size: 16px; color: #2A2F4C; line-height: 20px;"
                 v-if="resumeInfo.workerInfo.expectProvincename && resumeInfo.workerInfo.expectCityname">
              {{ resumeInfo.workerInfo.expectProvincename }}{{ resumeInfo.workerInfo.expectCityname }}
            </div>
            <div style="font-size: 16px; color: #2A2F4C; line-height: 20px;" v-else>未填</div>
          </div>-->
        </div>
        <!-- 备注 -->
        <div v-if="!resumeInfo.remark" style="height: 50px;width: 1px"></div>
        <div v-else class="remake-box" style="padding: 15px;background-color: rgba(243, 247, 255, 1); ">
          <div class="remake-operate flex align-start" :style="`${flex}${alignStart}`">
            <img style="width: 20px; height: 20px;" src="../../assets/images/home/icon_remke_msg.png" alt=""/>
            <span style="word-wrap: break-word; width: calc(100% - 53px); font-size: 14px; color: #5C6874; line-height: 20px; margin: 0 10px;">
              {{ `备注：${resumeInfo.remark}` }}
            </span>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <i class="el-icon-more"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="ReamkeEdit" style="color: rgba(0, 0, 0, 1);" @click="handleReamkeEdit">
                  <i class="el-icon-edit"/> 编辑备注
                </el-dropdown-item>
                <el-dropdown-item command="ReamkeDel" style="color: rgba(253, 107, 109, 1);" @click="handleReamkeDel">
                  <i class="el-icon-delete"/>删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- split line -->
        <div style="font-size: 12px; color: #5C6874; line-height: 17px; padding-right: 150px; padding-bottom: 27px; border-bottom: 1px solid #EFEFEF; margin-bottom: 37px;"/>
        <template v-if="resumeInfo.ecpList.length">
          <div :style="boxTitle">求职期望</div>
          <div :style="`${flex} margin-bottom: 36px;`">
            <div v-for="item in resumeInfo.ecpList" :key="item.workerId" :style="ecpItem">
              <div style="font-size: 16px; color: rgba(42, 47, 76, 1); font-weight: 500; line-height: 20px; margin-bottom: 8px;">
                {{ item.positionName }}
              </div>
              <div :style="`${flex} font-size: 14px;color:rgba(51, 51, 51, 1);`">
                <font>{{ item.cityName }}</font>
                <span style="width: 1px;height: 14px;background: #D8D8D8;margin: 0 12px"></span>
                <font v-if="item.minSalary">{{ `${item.minSalary}-${item.maxSalary}` }}</font>
              </div>
            </div>
          </div>
        </template>
        <div :style="boxTitle">基本信息</div>
        <div :style="`${flex} flex-wrap: wrap; margin-bottom: 36px; font-size: 14px; color: #666; line-height: 20px;`">
          <span style="margin-bottom: 16px; width: 230px;">姓 名：{{ resumeInfo.workerInfo.name }}</span>
          <span style="margin-bottom: 16px; width: calc(100% - 230px);">
            年龄：{{ resumeInfo.workerInfo.age }}
          </span>
          <span style="margin-bottom: 16px; width: 230px;">
            工作经历：{{ resumeInfo.workerInfo.experience }}
          </span>
          <span style="margin-bottom: 16px; width: calc(100% - 230px);">
            联系电话：{{ resumeInfo.workerInfo.phone }}
          </span>
          <span style="margin-bottom: 16px; width: 230px;">
            籍 贯：{{ resumeInfo.workerInfo.homeProvincename }}{{ resumeInfo.workerInfo.homeCityname }}
          </span>
          <span style="margin-bottom: 16px; width: calc(100% - 230px);">
            联系地址：{{ resumeInfo.workerInfo.address }}
          </span>
        </div>
        <div :style="boxTitle">个人优势</div>
        <div :style="advantage" v-if="advantageList.length">
          <span v-for="(adv, index) in advantageList" :key="index">{{ adv }}</span>
        </div>
        <div style="font-size: 14px; color: #666; line-height: 20px; margin-bottom: 36px;">
          自我描述：{{ resumeInfo.workerInfo.brief }}
        </div>
        <div :style="boxTitle">工作经历</div>
        <div style="padding-left: 28px; margin-bottom: 36px;" v-if="resumeInfo.expList.length">
          <div v-for="(item, index) in resumeInfo.expList"
               :key="item.id"
               style="position: relative; display: flex; padding-bottom: 30px;">
            <div style="width: 10px; height: 10px; background-color: rgba(5, 125, 249, 1); border-radius: 50%; margin-right: 16px; margin-top: 4px;"/>
            <div style="flex: 1;">
              <div class="item-exp-bi flex flex-between">
                <div class="flex">
                  <span>{{ item.positionName }}</span>
                  <span class="split-line-bi"></span>
                  <span>{{ item.companyName }}</span>
                </div>
                <div style="font-size: 14px; color: rgba(92, 104, 116, 1); line-height: 20px;">
                  {{ item.inTime.split(" ")[0]}} ~ {{ item.outTime.split(" ")[0] }}
                </div>
              </div>
              <div style="font-size: 14px; line-height: 20px; color: #666;">
                工作内容：<span style="color: #333333;" v-html="item.workDesc.replace(/\n/g, '<br>')"></span>
              </div>
            </div>
            <div v-if="index < resumeInfo.expList.length - 1"
                 style="width: 1px; height: 100%; position: absolute; left: 4.36px; top: 13px; border-left: 1px dashed rgba(4, 15, 36, 0.20);">
            </div> <!-- 线 -->
          </div>
        </div>
        <div style="margin-bottom: 36px; font-size: 14px; color: #666; line-height: 20px;" v-else>暂无工作经历</div>
        <div :style="boxTitle">视频介绍</div>
        <div class="video-box m-b-18" v-if="resumeInfo.videoUrl" @click="showVideo">
          <img class="video" :src="resumeInfo.videoUrl + '?vframe/jpg/offset/0'" alt=""/>
          <div class="video-title">视频简历</div>
          <img class="video-btn" src="../../assets/images/resume/video_play_icon.png" alt=""/>
        </div>
        <div style="margin-bottom: 36px; font-size: 14px; color: #666; line-height: 20px;" v-else>暂无视频上传</div>
      </div>
      <div class="feedback-btn flex flex-center" @click="feedbackVisible = true">
        <span class="flex flex-center">?</span>
      </div>
      <el-button style="position: absolute; top: 350px; left: 110px" v-if="!resumeInfo.remark" @click="handleReamkeEdit">
        添加备注
      </el-button>
      <div class="status-btns">
        <el-button v-if="!resumeInfo.workerInfo.isFavorite" icon="star-off" @click="onCommit(3)">收藏</el-button>
        <el-button v-else class="btn-active" icon="star-on" @click="onCommit(3)">已收藏</el-button>
        <el-button v-if="!resumeInfo.workerInfo.isColl" @click="handleColl">下载简历</el-button>
        <el-button v-if="resumeInfo.workerInfo.isColl" @click="doPrintVue">打印简历</el-button>
        <template v-if="!isCol && !resumeEliminate&& resumeInfo.workerInfo.isColl">
          <!--<el-button v-if="[1, 2, 11].includes(resumeInfo.status)" @click="handleResumeSuit">简历合适</el-button>-->
          <el-button v-if="[1, 2, 11, 12].includes(resumeInfo.status)" @click="onCommit(4)">约面试</el-button>
          <el-button v-if="[4].includes(resumeInfo.status)" @click="failViewVisible2 = true">面试通过</el-button>
          <el-button v-if="[6].includes(resumeInfo.status)" @click="onCommit(8)">不上岗</el-button>
          <el-button v-if="[1, 2, 11, 12, 4, 6].includes(resumeInfo.status)" @click="handleResumeSG">已上岗</el-button>
          <el-button v-if="[4].includes(resumeInfo.status)" class="btn-danger" @click="failViewVisible = true">
            不通过
          </el-button>
          <!--<el-button v-if="[8].includes(resumeInfo.status)" class="btn-active no-pointer">已上岗</el-button>-->
        </template>
        <el-button v-if="[1, 2, 11, 12, 6].includes(resumeInfo.status) && !isCol" class="btn-danger" @click="onCommit(1)">
          不合适
        </el-button>
      </div>
      <!--<div style="width: 120px;height: 300px; flex-shrink: 0;">
        <div class="button primary-border-btn" @click="onCommit(3)">
          <i :class="resumeInfo.workerInfo.isFavorite ? 'el-icon-star-on' : 'el-icon-star-off'"/>
          {{ resumeInfo.workerInfo.isFavorite ? '已收藏' : '收藏' }}
        </div>
        <template v-if="(resumeInfo.status === 1 || resumeInfo.status === 2) && resumeInfo.workerInfo.isColl === 0">
          <div class="button primary-btn" type="default" @click="onCommit(2)">下载简历</div>
          <div class="button error-border-btn" @click="onCommit(1)">不合适</div>
        </template>
        <template v-else-if="resumeInfo.status === 1 || resumeInfo.status === 2">
          <div class="button primary-btn" @click="doPrintVue">打印简历</div>
          <div class="button warning-btn" @click="onCommit(4)">约面</div>
          <div class="button error-border-btn" @click="onCommit(1)">不合适</div>
        </template>
        <template v-else-if="resumeInfo.status === 4">
          <div class="button warning-btn" type="default" @click="onCommit(6)">通过</div>
          <div class="button error-border-btn" @click="onCommit(5)">不合适</div>
        </template>
      </div>-->
      <el-dialog title="视频预览" :visible.sync="videoVisible">
        <video :src="videoUrl" v-if="videoUrl && videoVisible" autoplay></video>
      </el-dialog>
      <div class="modal" :class="{ fadeIn: isModalShow, fadeOut: !isModalShow }" v-if="isModalShow">
        <div class="modal-mask"></div>
        <div class="modal-con">
          <div class="modal-con-main" v-loading="loading">
            <div class="m-header">
              <span>确认操作</span>
              <span class="iconfont icon-guanbi" @click="isModalShow = !isModalShow"></span>
            </div>
            <div class="m-content">
              <div class="zf-txt" v-if="isPass">
                请确认 <span class="zf-name">{{ resumeInfo.name }}</span>已通过面试 并支付 <span class="zf-yuan">{{ carsubsidy }}元面试车补</span>给他吗？
              </div>
              <div class="zf-txt" v-if="!isPass">
                您确认 <span class="zf-name">{{ resumeInfo.name }}</span>不合适吗？您将支付 <span class="zf-yuan">{{ carsubsidy }}元面试车补</span>给他吗？
              </div>
              <div class="zf-yems">
                账户余额：<span class="zf-ye">{{ availableFunds }}元</span>
              </div>
              <div class="zf-zftxt" style="position: relative;">
                <p>请输入支付密码</p>
                <p v-if="passwordError" style="position: absolute; top:0; right: 0; color: #dc1010; font-size: 14px;">
                  请输入支付密码</p>
              </div>
              <input autocomplete="new-password"
                     style="font-size: 14px;"
                     v-model="password"
                     maxlength="20"
                     class="zf-input"
                     ref="passwordType"/>
            </div>
            <div class="m-grpups">
              <div class="m-cancel-button" @click="isModalShow = !isModalShow">下次再说</div>
              <div class="m-confirm-button" @click="payInterview">确认支付</div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog class="dialog-fail-view" title="面试不通过" :visible.sync="failViewVisible" size="large">
        <div class="fail-text">确认该候选人未通过面试，信息也会同步告知ta。</div>
        <div class="flex">
          <span class="spa">面试人有到场吗</span>
          <el-radio-group v-model="radio1">
            <el-radio :label="1">已面试</el-radio>
            <el-radio :label="2">未面试</el-radio>
          </el-radio-group>
        </div>
        <div class="bg-text" v-if="recruitInfo && recruitInfo.provideCarsubsidy">
          <img class="bg-icon" src="../../assets/images/home/icon_bt.png" alt=""/>
          该岗位已设置车补¥<font>{{ recruitInfo.carsubsidy }}</font>/人，确认后将从账户余额同步扣除
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="failViewVisible = false">取 消</el-button>
          <el-button type="primary" @click="onCommit(5)">确认不通过</el-button>
        </span>
      </el-dialog>
      <el-dialog class="dialog-fail-view" title="确认面试通过" :visible.sync="failViewVisible2" size="large">
        <div class="fail-text">确认该候选人面试通过，现在要给ta办理上岗</div>
        <div class="bg-text" v-if="recruitInfo && recruitInfo.provideCarsubsidy">
          <img class="bg-icon" src="../../assets/images/home/icon_bt.png" alt=""/>
          该岗位已设置车补¥<font>{{ recruitInfo.carsubsidy }}</font>/人，确认后将从账户余额同步扣除
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onCommit(6)">面试通过暂不上岗</el-button>
          <el-button type="primary" @click="onCommit(9)">确认上岗</el-button>
        </span>
      </el-dialog>
      <el-dialog class="dialog-feedback" title=" " :visible.sync="feedbackVisible" size="large">
        <div class="title">请反馈您的问题</div>
        <div class="feed-text">感谢您的反馈、我们会尽快处理！</div>
        <el-radio-group v-model="feedbackInfo.type">
          <el-radio-button label="1">电话联系失败</el-radio-button>
          <el-radio-button label="2">内容作假</el-radio-button>
          <el-radio-button label="3">下载失败</el-radio-button>
        </el-radio-group>
        <el-input type="textarea" :rows="3" placeholder="请描述您在使用中遇到的问题" v-model="feedbackInfo.content"/>
        <span slot="footer" class="dialog-footer">
          <el-button @click="feedbackVisible = false">取消</el-button>
          <el-button type="primary" @click="handleReportFd">提交</el-button>
        </span>
      </el-dialog>
      <Confirm :visible.sync="confirmVisible" v-bind="confirmInfo" v-if="confirmVisible"/>
    </div>
    <div class="log-off" v-if="isLogOff">
      <div class="log-off-content">
        <img src="../../assets/images/icon_log_off.png" alt="注销图标" class="log-off-icon">
        <div class="log-off-title">用户已注销</div>
        <div class="log-off-desc">用户已将自己的账号注销，所属内容已无法查看</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { sex } from "../../filters/";
  import Confirm from "../../components/NewConfirm.vue";

  const qs = require('qs');
  const styleInfo = {
    flex: "display: flex; align-items: center;",
    flexBetween: "justify-content: space-between;",
    flexColumn: "flex-direction: column;",
    alignStart: "align-items: flex-start;",
    boxTitle: "font-weight: bold; font-size: 22px; color: #141414; line-height: 30px; margin-bottom: 16px;",
    ecpItem: "width: 240px; height: 78px; background: linear-gradient( 90deg, #EDF6FD 0%, #FFFFFF 100%);border-radius: 4px; padding: 16px 0 0 16px;margin-right: 16px;",
    iItem: "width: 256px; height: 78px;margin-right: 16px;",
    advantage: "display: flex; align-items: center; width: 88px; height: 32px; background: #EDF6FD; border-radius: 4px; margin-right: 10px; font-size: 14px; color: #057DF9; text-align: center; line-height: 32px; margin-bottom: 16px;"
  };

  export default {
    components: {
      Confirm
    },
    data() {
      return {
        resumeInfo: null,
        options: {
          text: "加载中，请稍后",
          target: "#sinfo"
        },
        workerDeliverId: null, // 投递简历ID
        workerId: null, // 人才库id
        videoVisible: false,
        videoUrl: '',
        provideCarsubsidy: 0,
        isModalShow: false,
        loading: true,
        carsubsidy: 0,
        availableFunds: 0,
        isPass: true,
        password: '',
        passwordType: 'text',
        passwordError: '',
        isLogOff: false,
        recruitId: '',
        failViewVisible: false,
        radio1: 1,
        recruitInfo: null,
        failViewVisible2: false,
        feedbackVisible: false,
        feedbackInfo: {
          type: -1,
          content: ''
        },
        confirmVisible: false,
        confirmInfo: {
          name: '',
          workerId: null,
        },
        isCol: false,
        ...styleInfo,
      };
    },
    computed: {
      IconSex() {
        return this.resumeInfo.workerInfo.sex === '男' ? require("../../assets/images/home/icon_man.png") : require("../../assets/images/home/icon_woman.png");
      },
      advantageList() {
        return [];
        // return this.resumeInfo.workerInfo.advantageList.length > 0 ? this.resumeInfo.workerInfo.advantageList : ['未填'];
      },
      stepActive() {
        if (this.resumeInfo.workerInfo.isColl === 0) {
          return 0;
        }
        const status = this.resumeInfo.status;
        if (!this.resumeInfo.status) {
          return 1;
        }
        if ([1, 11].includes(status)) {
          return 1;
        } else if ([2, 3, 4, 5, 12].includes(status)) {
          return 2;
        } else if ([6, 7].includes(status)) {
          return 3;
        } else {
          return 4;
        }
      },
      resumeEliminate() { // 简历已淘汰
        return [3, 5, 7, 9, 10].includes(this.resumeInfo.status);
      },
      getActivityStatus() {
        const dateStr = this.resumeInfo.workerInfo.curloginAt;
        if (!dateStr) {
          return { text: '长期未活跃', bg: 'rgba(242, 243, 245, 1)', color: 'rgba(134, 144, 156, 1)' };
        }
        const targetDate = new Date(dateStr).getTime();
        const now = new Date().getTime();
        const diffDays = Math.floor((now - targetDate) / (1000 * 60 * 60 * 24));
        if (diffDays < 1) {
          return { text: '今天活跃', bg: 'rgba(255, 247, 232, 1)', color: 'rgba(252, 116, 66, 1)' };
        } else if (diffDays <= 7) {
          return { text: '本周活跃', bg: 'rgba(255, 247, 232, 1)', color: 'rgba(252, 116, 66, 1)' };
        } else if (diffDays <= 35) {
          return { text: '本月活跃', bg: 'rgba(245, 232, 255, 1)', color: 'rgba(120, 22, 255, 1)' };
        } else if (diffDays <= 180) {
          return { text: '半年内活跃', bg: 'rgba(232, 243, 255, 1)', color: 'rgba(0, 76, 249, 1)' };
        } else if (diffDays <= 365) {
          return { text: '当年活跃', bg: 'rgba(232, 243, 255, 1)', color: 'rgba(0, 76, 249, 1)' };
        } else {
          return { text: '长期未活跃', bg: 'rgba(242, 243, 245, 1)', color: 'rgba(134, 144, 156, 1)' };
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.loadingObj = vm.$loading(vm.options);
      });
    },
    created() {
      const query = this.$route.query;
      // 判断来源
      // if (id) {
      this.workerDeliverId = query.workerDeliverId;
      this.workerId = query.workerId;
      this.provideCarsubsidy = query.provideCarsubsidy;
      this.carsubsidy = query.carsubsidy;
      this.isCol = query.isCol;
      this.recruitId = query.recruitId;
      if (this.recruitId) {
        this.getrecruitInfo();
      }
      if (this.workerId) {
        this.axios.get('/wapi/company/detail').then(res => {
          this.recruitInfo = {
            companyId: res.data.id
          };
        });
      }
      this.getInfo();
      // }
    },
    filters: {
      sex: sex
    },
    watch: {
      password(newval) {
        let k = this.$refs.passwordType;
        if (newval.length > 0) {
          k.type = 'password';
        } else {
          k.type = 'txt';
        }
      },
      isModalShow() {
        this.password = '';
      }
    },
    methods: {
      getrecruitInfo() {
        this.axios.get(`/wapi/hr/recruit/get?recruitId=${this.recruitId}`).then(res => {
          let { data, success } = res;
          if (!success) {
            return;
          }
          this.recruitInfo = {
            provideCarsubsidy: data.provideCarsubsidy,
            carsubsidy: data.carsubsidy,
            companyId: data.companyId,
            createdAt: data.createdAt,
          }
        });
      },
      showVideo() {
        this.videoVisible = true;
        this.videoUrl = this.resumeInfo.videoUrl;
      },
      getMerry(value) {
        const obj = { '-1': '未知', 0: '单身', 1: '已婚', 2: '离异', 3: '丧偶' };
        return obj[value] || '未知';
      },
      getInfo() {
        let url = '';
        if (this.workerDeliverId) {
          url = `/wapi/hr/resume/get?workerDeliverId=${this.workerDeliverId}`;
        } else {
          url = `/wapi/hr/seeResume?workerId=${this.workerId}`;
        }
        this.axios.get(url).then(res => {
          this.loadingObj.close();
          if (res.status === 597) {
            this.isLogOff = true;
            return;
          }
          if (res.success) {
            this.resumeInfo = res.data;
          }
        });
      },
      onCommit(type) {
        const workerIdList = [this.resumeInfo.workerInfo.id];
        const workerDeliverIdList = [this.workerDeliverId];
        const item = this.resumeInfo.workerInfo;
        const recruitId = this.recruitId;
        /* 根据类型判断操作1:不合适 2:下载简历 3:收藏 7:简历合适  4:约面试  5: 面试不通过 6: 面试通过 8:不上岗 9 上岗
       * workerId: 工人id
       * workerDeliverId: 工人投递ID
       */
        const onOperate = (type, workerIdList, workerDeliverIdList) => {
          return new Promise(() => {
            let url = '';
            let params = {};
            let method = 'post';
            if (type === 1) {
              url = '/wapi/hr/resume/fail';
              params = {
                workerDeliverIdList
              };
            } else if (type === 2) {
              url = `/wapi/hr/collWorker?workerId=${workerIdList[0]}&recruitId=${recruitId}`;
              method = 'get';
            } else if (type === 3) {
              url = '/wapi/favorites/handle';
              const isFavorite = this.resumeInfo.workerInfo.isFavorite ? 0 : 1;
              params = {
                handleType: isFavorite,
                workerIds: [item.workerId || item.id]
              };
            } else if (type === 4) {
              url = '/wapi/hr/resume/gotoView?workerDeliverId=' + workerDeliverIdList[0];
              method = 'get';
            } else if (type === 5) {
              url = '/wapi/hr/resume/failView';
              const formData = new FormData();
              formData.append('workerDeliverId', workerDeliverIdList[0]);
              // params = {
              //   workerDeliverId: workerDeliverIdList[0]
              // };
              this.axios[method](url, formData, {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              }).then(res => {
                if (res.success) {
                  this.failViewVisible = false;
                  this.$message('操作成功');
                  this.getInfo();
                }
              });
              return;
            } else if (type === 6) {
              if (this.provideCarsubsidy === 1) {
                this.interviewPass();
                return
              }
              this.failViewVisible2 = false;
              url = '/wapi/hr/resume/successView?workerDeliverId=' + workerDeliverIdList[0];
              method = 'get';
            } else if (type === 7) {
              url = '/wapi/hr/resume/gotoWaitingView?workerDeliverId=' + workerDeliverIdList[0];
              method = 'get';
            } else if (type === 8) {
              url = '/wapi/hr/resume/failPost?workerDeliverId=' + workerDeliverIdList[0];
              method = 'get';
            } else if (type === 9) {
              this.failViewVisible2 = false;
              url = '/wapi/hr/resume/success?workerDeliverId=' + workerDeliverIdList[0];
              method = 'get';
            }
            this.axios[method](url, params).then(res => {
              if (res.success) {
                this.$message('操作成功');
                this.getInfo();
              }
            });
          });
        };
        onOperate(type, workerIdList, workerDeliverIdList);
      },
      downResume() {
        const url = `/wapi/hr/collWorker?workerId=${this.resumeInfo.workerInfo.id}&recruitId=${this.recruitId}`;
        const method = 'get';
        this.axios[method](url).then(res => {
          if (res.success) {
            this.$message('操作成功');
            this.getInfo();
          }
        });
      },
      interviewPass() {
        this.isModalShow = true;
        this.getRemain();
        this.isPass = true;
      },
      getRemain() {
        this.axios.get('/wapi/company/getRemain').then(res => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          this.availableFunds = res.data.availableFunds;
        });
      },
      payInterview() {
        let url = `/wapi/hr/resume/successView`;
        if (!this.isPass) {
          url = '/wapi/hr/resume/failView';
        }
        if (this.password.length === 0) {
          this.passwordError = '请输入支付密码';
          return;
        }
        let qdata = {
          workerDeliverId: this.rowList[this.index].id,
          password: this.password
        };
        this.loading = true;
        this.axios.post(url, qs.stringify(qdata)).then(res => {
          setTimeout(() => {
            this.loading = false;
          }, 300);
          if (res.success) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.password = '';
            this.isModalShow = false;
            this.getInfo();
          }
        });
      },
      doPrintVue() {
        // 要打印的部分
        const printhtml = document.getElementById('printOrder-data').innerHTML;
        // 生成并打印ifrme
        const f = document.getElementById('printf');
        f.contentDocument.write(printhtml);
        f.contentDocument.close();
        f.contentWindow.print();
      },
      // remake
      handleCommand(command) {
        this[`handle${command}`]()
      },
      handleReamkeDel() {
        const url = `/wapi/hr/resume/remark/del/${this.resumeInfo.workerInfo.id}`;
        this.$confirm('确认要删除该简历的备注内容吗？', '删除简历备注', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          // type: 'warning'
        }).then(() => {
          this.axios.post(url).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getInfo();
            }
          });
        });
      },
      handleReamkeEdit() {
        const url = `/wapi/hr/resume/remark/save`;
        const title = '编辑简历备注';
        const oldRemake = this.resumeInfo.remark;
        this.$prompt(' ', title, {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          inputValue: oldRemake,
          inputPlaceholder: '请输入备注内容',
        }).then(({ value }) => {
          const formData = new FormData();
          formData.append('remark', value);
          formData.append('workerId', this.resumeInfo.workerInfo.id);
          this.axios.post(url, formData).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '保存成功!'
              });
              this.getInfo();
            }
          });
        });
      },
      handleResumeSuit() {
        this.$confirm('确认该简历符合岗位招聘需求，现在需要帮您预约面试吗？', '确认简历合适', {
          confirmButtonText: '直接约面试',
          cancelButtonText: '简历合适稍后再约',
        }).then(() => {
          this.onCommit(4);
        }).catch(() => {
          this.onCommit(7);
        });
      },
      handleResumeSG() {
        this.$confirm('确认该候选人已通过面试，并且实际已上岗。', '确认已上岗', {
          confirmButtonText: '确认已上岗',
          cancelButtonText: '取消',
        }).then(() => {
          this.onCommit(9);
        });
      },
      handleReportFd() {
        const { type, content } = this.feedbackInfo;
        if (type === -1 && !content) {
          this.$message.error('反馈内容不能为空');
          return;
        }
        const url = '/wapi/hr/resume/feedback';
        const params = new FormData();
        params.append('workerId', this.resumeInfo.workerInfo.id);
        params.append('companyId', this.recruitInfo.companyId);
        type !== -1 && params.append('type', this.feedbackInfo.type);
        content && params.append('content', this.feedbackInfo.content);
        this.axios.post(url, params).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '反馈成功!'
            });
            this.feedbackVisible = false;
            this.feedbackInfo = {
              type: -1,
              content: ''
            };
          }
        });
      },
      handleColl() {
        // this.onCommit(2)
        this.confirmInfo = {
          name: this.resumeInfo.workerInfo.name,
          workerId: this.resumeInfo.workerInfo.id,
          recruitId: this.recruitId
        };
        this.confirmVisible = true;
      }
    }
  };
</script>

<style scoped lang="less">
  @import url('../../assets/less/base.less');
  @import "../../assets/css/resume";

  .button {
    margin-bottom: 16px;
  }

  .video-box {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    position: relative;

    .video {
      width: 100%;
      height: 100%;
    }

    .video-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 26px;
      height: 26px;
      margin-left: -13px;
      margin-top: -13px;
    }

    .video-title {
      position: absolute;
      font-size: 10px;
      background: #333333;
      color: #fff;
      padding: 0 6px;
      top: 8px;
      left: 9px;
      border-radius: 5px;
    }
  }

  .modal {
    animation-duration: .3s;

    .modal-mask {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: .5;
      background: #000;
      z-index: 2004;
    }

    .modal-con {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      z-index: 2005;

      &::after {
        content: "";
        display: inline-block;
        height: 100%;
        width: 0;
        vertical-align: middle;
      }
    }

    .modal-con-main {
      text-align: left;
      display: inline-block;
      vertical-align: middle;
      background-color: #fff;
      width: 500px;
      height: 375px;
      border-radius: 3px;
      font-size: 16px;
      overflow: hidden;
      backface-visibility: hidden;

      .m-header {
        position: relative;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        background-color: @blue;
        color: #fff;

        .iconfont {
          position: absolute;
          font-size: 14px;
          right: 25px;
          cursor: pointer;
          /*top: 15px;*/
        }
      }

      .m-content {
        width: 440px;
        margin: 0 auto;
        color: #666;
      }

      .zf-txt {
        color: #666;
        font-size: 16px;
        margin-top: 23px;
        margin-bottom: 25px;

        .zf-name {
          color: #495fcd;
          margin: 0 2px 0 4px;
        }

        .zf-yuan {
          color: #ff6511;
        }
      }

      .zf-yems {
        color: #666;
        padding-bottom: 25px;
        border-bottom: 1px dashed #e5e5e5;

        span {
          color: #ff6511;
        }
      }

      .zf-zftxt {
        margin-top: 25px;
        margin-bottom: 5px;
      }

      .zf-input {
        width: 100%;
        height: 40px;
        outline: none;
        border: 1px solid #ccc;
        border-radius: 5px;

        &:focus {
          border-color: #495fcd;
        }
      }

      .m-grpups {
        float: right;
        overflow: hidden;
        padding: 33px 0;

        div {
          width: 140px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          float: left;
          margin-right: 30px;
          font-size: 14px;
          cursor: pointer;
        }

        .m-cancel-button {
          border: 1px solid #666;
          color: #666;
        }

        .m-confirm-button {
          border: 1px solid #ff6511;
          color: #fff;
          background-color: #ff6511;
        }
      }

    }
  }

  .down-resume {
    text-decoration: underline;
    color: #057CF9;
    cursor: pointer;
  }

  .container {
  }

  #sinfo {
    position: relative;
  }

  .log-off {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    .log-off-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .log-off-icon {
      width: 120px;
      height: 120px;
      margin-bottom: 24px;
    }

    .log-off-title {
      font-size: 20px;
      color: #333;
      margin-bottom: 12px;
    }

    .log-off-desc {
      font-size: 14px;
      color: #999;
    }
  }

  .com-model {
    position: relative;
    border-radius: 10px;
    background: none;
  }

  header {
    padding: 24px;
    background-color: #ffffff;
    border-radius: 8px;

    .back-c {
      width: 24px;
      height: 24px;
      background: #F8F9FC;
      border-radius: 5px;
      margin-right: 8px;
      text-align: center;
      cursor: pointer;

      .el-icon-arrow-left {
        font-size: 12px;
      }
    }

    .top-tit {
      font-weight: bold;
      font-size: 22px;
      color: #141414;
      line-height: 30px;
    }

    .bottom {
      font-size: 14px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 14px;
      margin-top: 16px;

      .split-line {
        width: 1px;
        height: 14px;
        background: #D8D8D8;
        margin: 0 12px;
      }

      .post-status {
        width: 44px;
        height: 16px;
        background: linear-gradient(90deg, #69A1FF 0%, #82E1FF 100%);
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        line-height: 16px;
        margin-left: 6px;
      }
    }
  }

  .body-content {
    margin-top: 12px;
    border-radius: 8px;
    background-color: #ffffff;

    > * {
      margin-left: 110px;
    }

    .marginLeft {
      margin-left: 26px !important;;
    }
  }

  .info-bstatus {
    margin-left: 26px !important;
    margin-bottom: 28px;

    .person {
      width: 68px;
      height: 68px;
      border-radius: 34px;
      margin-right: 16px;
    }

    .icon-sex {
      width: 16px;
      height: 16px;
      margin-left: 6px;
    }

    .name {
      font-weight: bold;
      font-size: 22px;
      color: #141414;
      line-height: 28px;
      margin-bottom: 10px;
    }

    .oinfo {
      font-size: 16px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 14px;

      span {
        position: relative;
        margin-left: 25px;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -12.5px;
          width: 1px;
          height: 14px;
          background: #D8D8D8;
        }
      }
    }
  }

  /deep/ .el-step {
    .el-step__title {
      color: rgba(20, 20, 20, 1) !important;
      font-size: 12px;
      margin-left: -10px;
    }

    .is-finish .el-step__icon i {
      color: rgba(2, 119, 255, 1) !important;
    }
  }

  .remake-box {
    padding: 15px;
    background-color: rgba(243, 247, 255, 1);

    .el-dropdown {
      cursor: pointer;
    }
  }

  .remake-btn {
  }

  .item-exp-bi {
    font-size: 16px;
    color: #2A2F4C;
    line-height: 16px;
    margin-bottom: 16px;

    .split-line-bi {
      width: 1px;
      height: 14px;
      background: #D8D8D8;
      margin: 0 14px;
    }
  }

  .btn-active {
    background-color: rgba(237, 246, 253, 1);
    color: rgba(5, 124, 249, 1);
    border: none;

    .el-icon-star-on {
      color: rgba(5, 124, 249, 1);
    }
  }

  .btn-danger {
    background-color: rgba(253, 107, 109, 1);
    color: #ffffff;
  }

  .status-btns {
    position: absolute;
    right: 24px;
    top: 173px;
  }

  .no-pointer {
    cursor: no-drop;
  }

  .dialog-fail-view /deep/ .el-dialog {
    width: 432px;
    border-radius: 12px;

    .el-dialog__body {
      padding: 14px 20px;

      .fail-text {
        font-size: 14px;
        color: #606266;
        line-height: 24px;
        margin-bottom: 15px;
      }

      .spa {
        margin-right: 43px;
        font-size: 14px;
        color: #606266;
        line-height: 14px;
      }

      .bg-text {
        display: flex;
        align-items: center;
        margin-top: 8px;
        padding-left: 10px;
        font-size: 12px;
        color: #606266;
        height: 28px;
        background-color: rgba(254, 74, 111, .2);

        font {
          color: rgba(255, 77, 79, 1);
        }

        .bg-icon {
          width: 15.6px;
          height: 15.6px;
          margin-right: 4px;
        }
      }
    }
  }

  .dialog-feedback /deep/ .el-dialog {
    width: 506px;

    .el-dialog__body {
      padding: 0 20px;

      .title {
        text-align: center;
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 33px;
        margin-bottom: 10px;
      }

      .feed-text {
        font-size: 14px;
        color: #606266;
        line-height: 24px;
        text-align: center;
        margin-bottom: 30px;
      }

      .el-radio-group {
        margin-bottom: 16px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .el-radio-button .el-radio-button__inner {
          width: 144px;
          height: 40px;
          line-height: 40px;
          padding: 0;
          border: 1px solid #DCDFE6;
          border-radius: 4px;
          box-shadow: none;
        }

        .el-radio-button.is-active .el-radio-button__inner {
          background: linear-gradient(90deg, #0277FF 0%, #1AAFFD 100%);
        }
      }
    }
  }

  .feedback-btn {
    position: fixed;
    right: 50px;
    bottom: 124px;
    width: 50px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 25px;
    z-index: 111;
    cursor: pointer;

    span {
      width: 20px;
      height: 20px;
      border: 1px solid #333333;
      border-radius: 50%;
    }
  }

  @media print {
    .remake-btn {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// info.vue?3d3a6705